import React, { useState, useEffect } from 'react';
import { Dialog, Box, IconButton, Typography, Fab } from '@mui/material';
import { Close, NavigateBefore, NavigateNext, ZoomIn, ZoomOut } from '@mui/icons-material';

const PhotoLightbox = ({ photos, initialIndex = 0, open, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    setCurrentIndex(initialIndex);
    setZoom(1);
  }, [initialIndex, open]);

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : photos.length - 1));
    setZoom(1);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev < photos.length - 1 ? prev + 1 : 0));
    setZoom(1);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowLeft') handlePrevious();
    if (e.key === 'ArrowRight') handleNext();
    if (e.key === 'Escape') onClose();
  };

  useEffect(() => {
    if (open) {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [open, currentIndex]);

  if (!photos || photos.length === 0) return null;
  const currentPhoto = photos[currentIndex];

  return (
    <Dialog fullScreen open={open} onClose={onClose} PaperProps={{ sx: { bgcolor: 'rgba(0,0,0,0.95)' } }}>
      <IconButton onClick={onClose} sx={{ position: 'absolute', top: 16, right: 16, color: 'white', zIndex: 1300 }}>
        <Close />
      </IconButton>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', position: 'relative', p: 4 }}>
        <img src={currentPhoto.url} alt={currentPhoto.caption || currentPhoto.original_name} style={{ maxWidth: '90%', maxHeight: '90%', objectFit: 'contain', transform: `scale(${zoom})`, transition: 'all 0.3s' }} />
        {photos.length > 1 && (
          <>
            <Fab onClick={handlePrevious} sx={{ position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)' }} color="primary"><NavigateBefore /></Fab>
            <Fab onClick={handleNext} sx={{ position: 'absolute', right: 16, top: '50%', transform: 'translateY(-50%)' }} color="primary"><NavigateNext /></Fab>
          </>
        )}
        <Box sx={{ position: 'absolute', bottom: 16, right: 16, display: 'flex', gap: 1 }}>
          <IconButton onClick={() => setZoom(z => Math.max(0.5, z - 0.25))} sx={{ bgcolor: 'rgba(255,255,255,0.1)', color: 'white' }}><ZoomOut /></IconButton>
          <IconButton onClick={() => setZoom(z => Math.min(3, z + 0.25))} sx={{ bgcolor: 'rgba(255,255,255,0.1)', color: 'white' }}><ZoomIn /></IconButton>
        </Box>
        <Box sx={{ position: 'absolute', bottom: 16, left: 16, color: 'white' }}>
          <Typography variant="body2">{currentPhoto.caption}</Typography>
          <Typography variant="caption" color="grey.400">{currentIndex + 1} / {photos.length}</Typography>
        </Box>
      </Box>
    </Dialog>
  );
};

export default PhotoLightbox;
